import { useTranslation } from 'react-i18next';
import { PublicPageLayout } from '../../layout/PublicPageLayout';

/**
 * Pagina pubblica Privacy Policy. Contenuto via i18n (chiavi `privacy.*`),
 * struttura JSX statica: 9 sezioni numerate + heading + lastUpdated + 2
 * intro + contact email. Pattern replicato da
 * feelhippoai/UserSettingsPrivacyPolicy.tsx, contenuto adattato al dominio
 * CRM (vedi commit i18n in TS-7 Step 2).
 *
 * Route: `/privacy-policy` (pubblica, no auth).
 */
export function PrivacyPolicyPage() {
  const { t } = useTranslation();

  return (
    <PublicPageLayout selfPage="privacy">
      <h1>{t('privacy.heading')}</h1>
      <p>
        <em>{t('privacy.lastUpdated')}</em>
      </p>
      <p>{t('privacy.intro1')}</p>
      <p>{t('privacy.intro2')}</p>

      <h2>{t('privacy.section1.title')}</h2>
      <p>{t('privacy.section1.intro')}</p>
      <ul>
        <li>{t('privacy.section1.item1')}</li>
        <li>{t('privacy.section1.item2')}</li>
        <li>{t('privacy.section1.item3')}</li>
        <li>{t('privacy.section1.item4')}</li>
      </ul>
      <p>{t('privacy.section1.outro')}</p>

      <h2>{t('privacy.section2.title')}</h2>
      <p>{t('privacy.section2.intro')}</p>
      <ul>
        <li>{t('privacy.section2.item1')}</li>
        <li>{t('privacy.section2.item2')}</li>
        <li>{t('privacy.section2.item3')}</li>
        <li>{t('privacy.section2.item4')}</li>
      </ul>

      <h2>{t('privacy.section3.title')}</h2>
      <p>{t('privacy.section3.intro')}</p>
      <ul>
        <li>{t('privacy.section3.item1')}</li>
        <li>{t('privacy.section3.item2')}</li>
      </ul>
      <p>{t('privacy.section3.outro')}</p>

      <h2>{t('privacy.section4.title')}</h2>
      <p>{t('privacy.section4.content')}</p>

      <h2>{t('privacy.section5.title')}</h2>
      <p>{t('privacy.section5.content1')}</p>
      <p>{t('privacy.section5.content2')}</p>

      <h2>{t('privacy.section6.title')}</h2>
      <p>{t('privacy.section6.intro')}</p>
      <ul>
        <li>{t('privacy.section6.item1')}</li>
        <li>{t('privacy.section6.item2')}</li>
        <li>{t('privacy.section6.item3')}</li>
      </ul>
      <p>{t('privacy.section6.outro')}</p>

      <h2>{t('privacy.section7.title')}</h2>
      <p>{t('privacy.section7.content')}</p>

      <h2>{t('privacy.section8.title')}</h2>
      <p>{t('privacy.section8.content')}</p>

      <h2>{t('privacy.section9.title')}</h2>
      <p>{t('privacy.section9.content')}</p>
      <p>
        <a href="mailto:support@d-vel.com">{t('privacy.section9.email')}</a>
      </p>
    </PublicPageLayout>
  );
}
